import "./costCard.css"

export default function CostCard({ category, price, note }) {
  return (
    <div className="cost-card-container">
      <h1>{category}</h1>
      <span>{price}</span>
      <p>{note}</p>
    </div>
  );
}
